var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3145",
    filter: "url(#filter0_d_4883_15600)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9527 10.7426C21.6905 10.7426 23.0918 12.1424 23.0918 13.8814C23.0918 15.6193 21.6907 17.0192 19.9527 17.0192C18.2148 17.0192 16.8137 15.6196 16.8137 13.8814C16.8137 12.1427 18.215 10.7426 19.9527 10.7426ZM7.06169 7.63306H21.4603L21.1259 9.98672C20.7531 9.87558 20.3602 9.81263 19.9527 9.81263C19.2293 9.81263 18.5492 10.0059 17.96 10.3403V9.44994C17.9642 9.18733 17.7501 8.97365 17.4874 8.97857C17.2315 8.98275 17.0264 9.19373 17.0303 9.44994V11.0588C16.3236 11.7913 15.8855 12.7862 15.8855 13.8814C15.8855 14.4 15.9865 14.8957 16.166 15.353H9.08733C8.74678 15.353 8.5149 15.2712 8.3563 15.143C8.19746 15.0135 8.08484 14.8281 8.03861 14.504L7.06169 7.63306ZM5.91264 5.32144H22.6076C22.8916 5.32144 23.0915 5.5211 23.0915 5.7697V6.25656C23.0915 6.50344 22.8916 6.70458 22.6076 6.70458H5.91264C5.62839 6.70458 5.42971 6.50344 5.42971 6.25656V5.7697C5.42996 5.5211 5.62864 5.32144 5.91264 5.32144ZM11.5118 0.981228H17.0085C17.3527 0.981228 17.4579 1.03508 17.5939 1.15286C17.7282 1.27162 17.8907 1.51653 18.1354 1.87012L19.8773 4.39173H8.64178L10.3847 1.87012C10.6296 1.51653 10.7923 1.27162 10.9281 1.15286C11.0638 1.03508 11.1686 0.981228 11.5118 0.981228ZM11.5118 0.0515155C11.02 0.0515155 10.6077 0.200033 10.3156 0.454776C10.0249 0.708781 9.85205 1.00803 9.62141 1.34219L7.5124 4.39173H5.91264C5.14669 4.39173 4.5 5.00523 4.5 5.7697V6.25656C4.5 7.02104 5.14669 7.63306 5.91264 7.63306H6.12362L7.11775 14.6345C7.1893 15.1391 7.41208 15.5758 7.76936 15.8655C8.12689 16.1549 8.59186 16.283 9.08709 16.283H16.678C17.4193 17.2909 18.6104 17.9491 19.9525 17.9491C22.1935 17.9491 24.02 16.1212 24.02 13.8814C24.02 12.3905 23.2093 11.0856 22.0081 10.3774L22.3971 7.63281H22.6074C23.3731 7.63281 24.0198 7.02079 24.0198 6.25632V5.76945C24.0198 5.00498 23.3731 4.39148 22.6074 4.39148H21.0091L18.8996 1.34195C18.669 1.00778 18.4949 0.708289 18.2042 0.45453C17.9133 0.199787 17.501 0.0512695 17.0082 0.0512695H11.5118V0.0515155Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.9465 11.9595C19.69 11.9635 19.4864 12.1732 19.4891 12.4297V13.4167H18.5029C18.2442 13.4118 18.0303 13.6215 18.0303 13.8817C18.0303 14.1416 18.2442 14.3506 18.5029 14.3466H19.4891V15.3341C19.4891 15.954 20.4189 15.954 20.4189 15.3341V14.3466H21.4066C21.6665 14.3506 21.879 14.1418 21.879 13.8817C21.879 13.6215 21.6665 13.4118 21.4066 13.4167H20.4189V12.4297C20.4213 12.1683 20.2086 11.9556 19.9465 11.9595Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.0189 8.97761C10.7627 8.98179 10.5579 9.19277 10.5616 9.44899V13.3972C10.5579 13.6559 10.7664 13.8686 11.0266 13.8686C11.2857 13.8686 11.4942 13.6559 11.4905 13.3972V9.44923C11.4955 9.18662 11.2813 8.97294 11.0189 8.97761Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.2536 8.97761C13.9961 8.98179 13.7913 9.19277 13.795 9.44899V13.3972C13.7925 13.6559 14.0013 13.8686 14.2599 13.8686C14.5201 13.8686 14.7284 13.6559 14.7249 13.3972V9.44923C14.7286 9.18662 14.5149 8.97294 14.2536 8.97761Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4883_15600",
    x: 0.5,
    y: 0.0512695,
    width: 27.5195,
    height: 25.8979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4883_15600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4883_15600",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartProduct);
export default __webpack_public_path__ + "static/media/cart-product.5829ce1324025e99f9cbc24163861dea.svg";
export { ForwardRef as ReactComponent };